
const tKey = 'DOSSIER_COMPONENTS.FINANCE.'
export const financingRadioOptions = [
  { id: 'yes', label: `${tKey}RADIO_OPTIONS.YES`, value: 'true' },
  { id: 'no', label: `${tKey}RADIO_OPTIONS.NO`, value: 'false' }
]
